import React from 'react';
import TextArea from 'antd/es/input/TextArea';
import { Button } from 'antd';
const Feedback = () => {
  return (
    <div>
    <h4>Your feedback is highly appriciated</h4>
      <TextArea size='large'/>
      <Button>Submit</Button>
    </div>
  );
}

export default Feedback;
